import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import AdminToggleDark from './dashboard/AdminToggleDark.vue';
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';
export default {
  name: 'DashboardTabs',
  props: {
    activeTab: {
      type: String,
      default: 'dashboard'
    }
  },
  components: {
    AdminToggleDark,
    LanguageSwitcher
  },
  data() {
    return {
      isPageMenuOpen: false,
      hoveredPageOptionIndex: null
    };
  },
  computed: {
    pageOptions() {
      return [{
        name: 'dashboard',
        icon: 'images',
        label: 'dashboardTabs.fileManagement'
      }, {
        name: 'customerConfig',
        icon: 'user-cog',
        label: 'dashboardTabs.userManagement'
      }, {
        name: 'systemConfig',
        icon: 'cogs',
        label: 'dashboardTabs.systemSettings'
      }, {
        name: '',
        icon: 'upload',
        label: 'dashboardTabs.fileUpload'
      }];
    },
    activePageOption() {
      return this.pageOptions.find(option => option.name === this.activeTab) || this.pageOptions[0];
    },
    inactivePageOptions() {
      return this.pageOptions.filter(option => option.name !== this.activePageOption.name);
    }
  },
  methods: {
    handleDocumentClick(event) {
      if (this.$el?.contains(event.target)) {
        return;
      }
      this.closePageMenu();
    },
    refreshDashboard() {
      location.reload();
    },
    handleTabClick(tab) {
      this.closePageMenu();
      if (tab === this.activeTab) {
        this.refreshDashboard();
        return;
      }
      const routeName = tab || 'home';
      if (this.$route.name === routeName) {
        return;
      }
      this.$router.push({
        name: routeName
      });
    },
    isTouchViewport() {
      return window.matchMedia('(hover: none), (pointer: coarse)').matches;
    },
    handlePageOptionClick(tab) {
      if (this.isTouchViewport() && !this.isPageMenuOpen && tab !== this.activeTab) {
        this.openPageMenu();
        return;
      }
      if (tab === this.activeTab) {
        if (this.isTouchViewport()) {
          this.togglePageMenu();
        } else {
          this.openPageMenu();
        }
        return;
      }
      this.handleTabClick(tab);
    },
    handlePageSwitcherEnter() {
      if (!this.isTouchViewport()) {
        this.openPageMenu();
      }
    },
    handlePageSwitcherLeave() {
      if (!this.isTouchViewport()) {
        this.closePageMenu();
      }
    },
    setHoveredPageOption(index) {
      this.hoveredPageOptionIndex = index;
    },
    clearHoveredPageOption() {
      this.hoveredPageOptionIndex = null;
    },
    openPageMenu() {
      this.isPageMenuOpen = true;
    },
    togglePageMenu() {
      this.isPageMenuOpen = !this.isPageMenuOpen;
    },
    closePageMenu() {
      this.isPageMenuOpen = false;
      this.clearHoveredPageOption();
    }
  },
  mounted() {
    document.addEventListener('click', this.handleDocumentClick);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleDocumentClick);
  }
};